const Totales = ({calculado, electivas}) => {
  return (
    <div className='card py-3 m-3 text-center'>
        <div className='card-body row'>
            <h5>
                Horas De La Carrera: 159
            </h5>
            <h5>
            Horas Cursadas: {calculado}
          </h5>
          <h5>
            Horas De Electivas Cursadas: {electivas}
          </h5>
          <h5>
            Horas De Electivas del plan: 22 (mínimo)
          </h5>
          <h5>
            Horas De Electivas Faltantes: {22 - electivas <= 0 ? 'No me faltan horas' : 22 - electivas}
          </h5>
          <h5>
            Horas Faltantes Para Pedir La Nota 5.3.1: {129 - calculado <= 0 ? 'No me faltan horas' : 129 - calculado}
          </h5>
        </div>

    </div>
  )
}

export default Totales;